import * as React from 'react';
import { Link } from 'react-router-dom';
import AllowButton from './AllowButton';
import { fetchOauthUrl } from '../logic/api/BizServer';
import Loading from './Loading';
import Failure from './Failure';
import AppBar from './AppBar';
import topPng from '../images/top.png';
import calPng from '../images/cal.png';
import csvPng from '../images/csv.png';

interface Props {
  callbackUrl: string;
  setCallbackUrl: (callbackUrl: string) => void;
}

interface State {
  isLoading: boolean;
}

class AllowCalendarAccess extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: true
    };
  }
  componentDidMount() {
    if (this.props.callbackUrl === '') {
      set(this.props.setCallbackUrl, () => {
        this.setState({
          isLoading: false
        });
      });
    } else {
      this.setState({
        isLoading: false
      });
    }
  }
  render() {
    const titleStyle = {
      fontFamily: 'Josefin Sans',
      fontSize: '50px'
    };
    const imgStyle = {
      width: '600px',
      height: 'auto'
    };
    const marginBottom = {
      marginBottom: '100px'
    };
    if (this.state.isLoading) {
      return <Loading />;
    }
    if (this.props.callbackUrl) {
      return (
        <div>
          <section className="hero is-medium is-primary is-bold">
            <AppBar path="/" />
            <div className="container">
              <div className="level">
                <div>
                  <p style={titleStyle}>expenses automation</p>
                  <p className="subtitle">
                    Google Caledar
                    に登録した予定から交通費を計算し経費精算用にフォーマットしたCSVを出力
                  </p>
                  <div className="level-left">
                    <p className="level-item">
                      <AllowButton callbackUrl={this.props.callbackUrl} />
                    </p>
                    <p className="level-item">
                      <Link to="/tutorial" className="button is-large is-info">
                        <span className="icon is-medium">
                          <i className="fas fa-info-circle" />
                        </span>
                        <span>TUTORIAL</span>
                      </Link>
                    </p>
                  </div>
                </div>
                <div>
                  <figure className="image">
                    <img src={topPng} alt="logo" />
                  </figure>
                </div>
              </div>
            </div>
          </section>
          <section className="hero is-light">
            <div className="hero-body">
              <div style={marginBottom} />
              <div className="container has-text-centered">
                <p className="title is-1 is-spaced">
                  expenses automation でできること
                </p>
                <div className="level">
                  <div className="level-item">
                    <figure className="image">
                      <img src={calPng} style={imgStyle} alt="logo" />
                    </figure>
                  </div>
                  <div className="level-item">
                    <figure className="image">
                      <img src={csvPng} style={imgStyle} alt="logo" />
                    </figure>
                  </div>
                </div>
                <div className="level">
                  <div className="level-item">
                    <p className="subtitle">
                      カレンダーに"【駅名】訪問先"のフォーマットで登録
                    </p>
                  </div>
                  <div className="level-item">
                    <p className="subtitle">
                      予定と予定の間を移動とみなし交通費を計算してCSVファイルを作成
                    </p>
                  </div>
                </div>
                <div style={marginBottom} />
                <AllowButton callbackUrl={this.props.callbackUrl} />
                <Link to="/tutorial" className="button is-large is-info">
                  <span className="icon is-medium">
                    <i className="fas fa-info-circle" />
                  </span>
                  <span>TUTORIAL</span>
                </Link>
              </div>
            </div>
          </section>
        </div>
      );
    }
    return <Failure errorMessage="Cannot access" />;
  }
}

const set = async (
  setCallbackUrl: (url: string) => void,
  setState: () => void
): Promise<void> => {
  const url = await fetchOauthUrl();
  setCallbackUrl(url);
  setState();
};

export default AllowCalendarAccess;



// WEBPACK FOOTER //
// ./src/components/AllowCalendarAccess.tsx